import { MeetingProvider } from "@videosdk.live/react-sdk";
import { useEffect, useState } from "react";
import { MeetingAppProvider } from "./MeetingAppContextDef";
import { MeetingContainer } from "../meeting/MeetingContainer";
import { LeaveScreen } from "../Components/screens/LeaveScreen";
import { JoiningScreen } from "../Components/screens/JoiningScreen";
import "./Meeting.css";

function MeetingNew(props) {
  console.log("propsmeeting", props, props?.callroute);

  const [token, setToken] = useState("");
  const [meetingId, setMeetingId] = useState("");
  const [participantName, setParticipantName] = useState("Dr. Shubha");
  const [micOn, setMicOn] = useState(true);
  const [webcamOn, setWebcamOn] = useState(
    props?.callroute === "video" ? true : false
  );
  const [selectedMic, setSelectedMic] = useState({ id: null });
  const [selectedWebcam, setSelectedWebcam] = useState({ id: null });
  const [selectWebcamDeviceId, setSelectWebcamDeviceId] = useState(
    selectedWebcam.id
  );

  const [selectMicDeviceId, setSelectMicDeviceId] = useState(selectedMic.id);
  const [isMeetingStarted, setMeetingStarted] = useState(false);
  const [isMeetingLeft, setIsMeetingLeft] = useState(false);

  const isMobile = window.matchMedia(
    "only screen and (max-width: 768px)"
  ).matches;

  useEffect(() => {
    if (isMobile) {
      window.onbeforeunload = () => {
        return "Are you sure you want to exit?";
      };
    }
    setParticipantName("Dr Shubha Ukali");
  }, [isMobile]);

  useEffect(() => {
    if (isMeetingLeft) {
      props?.handleMeetingLeave();
      setSelectedMic(null);
      setSelectedWebcam(null);
    }
  }, [isMeetingLeft]);

  return (
    <>
      {isMeetingStarted ? (
        <MeetingAppProvider
          selectedMic={selectedMic}
          selectedWebcam={props?.callroute === "video" ? selectedWebcam : null}
          initialMicOn={micOn}
          initialWebcamOn={webcamOn && props?.callroute === "video"}
        >
          <MeetingProvider
            config={{
              meetingId,
              micEnabled: micOn,
              webcamEnabled: webcamOn && props?.callroute === "video",
              name: props?.participant,
              multiStream: true,
            }}
            token={token}
            reinitialiseMeetingOnConfigChange={true}
            joinWithoutUserInteraction={true}
          >
            <MeetingContainer
              onMeetingLeave={() => {
                setToken("");
                setMeetingId("");
                setParticipantName("");
                setWebcamOn(false);
                setMicOn(false);
                setMeetingStarted(false);
                props.handleMeetingLeave();
              }}
              setIsMeetingLeft={setIsMeetingLeft}
              selectedMic={selectedMic}
              selectedWebcam={props?.callroute === "video" ? selectedWebcam : null}
              selectWebcamDeviceId={
                props?.callroute === "video" ? selectWebcamDeviceId : null
              }
              setSelectWebcamDeviceId={
                props?.callroute === "video"
                  ? setSelectWebcamDeviceId
                  : () => {}
              }
              selectMicDeviceId={selectMicDeviceId}
              setSelectMicDeviceId={setSelectMicDeviceId}
              micEnabled={micOn}
              webcamEnabled={webcamOn && props?.callroute === "video"}
            />
          </MeetingProvider>
        </MeetingAppProvider>
      ) : isMeetingLeft ? (
        <LeaveScreen setIsMeetingLeft={setIsMeetingLeft} />
      ) : (
        <JoiningScreen
          participantName={participantName}
          setParticipantName={setParticipantName}
          setMeetingId={setMeetingId}
          setToken={setToken}
          setMicOn={setMicOn}
          micEnabled={micOn}
          webcamEnabled={webcamOn && props?.callroute === "video"}
          setSelectedMic={setSelectedMic}
          setSelectedWebcam={
            props?.callroute === "video" ? setSelectedWebcam : () => {}
          }
          setWebcamOn={props?.callroute === "video" ? setWebcamOn : () => {}}
          onClickStartMeeting={() => {
            setMeetingStarted(true);
          }}
          startMeeting={isMeetingStarted}
          setIsMeetingLeft={setIsMeetingLeft}
          consultaionId={props.consultaionId}
          showCommunication={props.showCommunication}
          type={props.consultaion}
          userId={props.userId}
        />
      )}
    </>
  );
}

export default MeetingNew;
